import { render, staticRenderFns } from "./zoho-view-selector.vue?vue&type=template&id=1b6eceb7"
import script from "./zoho-view-selector.vue?vue&type=script&lang=js"
export * from "./zoho-view-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports